const burger = document.querySelector('.burger');
const menu = document.querySelector('.menu');
const menuLine = document.querySelector('.menu__line');
const menuItems = document.querySelectorAll('.menu__item');
const menuLink = document.querySelectorAll('.menu__link');
const body = document.querySelector('.body');

burger.addEventListener('click', () => {
    burger.classList.toggle('burger--active');
    menu.classList.toggle('menu--active');
    body.classList.toggle('body--hidden');
});


menuLink.forEach(function (item, idx) {
    item.addEventListener('click', function () {
        burger.classList.remove('burger--active');
        menu.classList.remove('menu--active');
        body.classList.remove('body--hidden');
    });
});


document.addEventListener('DOMContentLoaded', () => {

    menuLine.style.width = `${menuItems[0].offsetWidth}px`;

    menuItems.forEach(el => {
        el.addEventListener('mouseenter', (e) => {
            menuLine.style.width = `${e.currentTarget.offsetWidth}px`;
            menuLine.style.left = `${e.currentTarget.offsetLeft}px`;
            menuLine.style.opacity = `1`;
        });
        el.addEventListener('mouseleave', () => {
            menuLine.style.width = `0px`;
            menuLine.style.left = `0px`;
        });
    });
});
